import {
  Button,
  Flex,
  Modal,
  Radio,
  Select,
  Tag,
  Tooltip,
  Typography,
  Table as ATable,
  message,
  Pagination,
} from 'antd';
import { useEffect, useState } from 'react';
import CustomButton from '../../../common/Button/Button';
import { DeleteOutlined, EditOutlined, LockOutlined } from '@ant-design/icons';
import colors from '../../../../constants/ColourConstants';
import { getTransactionByInvoiceId } from '../../../../services/InvoiceAPIs';
import moment from 'moment';

export default function CreatePayoutModal({
  onOk,
  open,
  setOpen,
  n,
  disabled,
  count,
  selectedRecords,
  handleCreatePayout,
}) {
  const { Text } = Typography;
  const [createPayoutType, setCreatePayoutType] = useState('all');
  const [createPayoutSubType, setCreatePayoutSubType] = useState('payout');
  const [confirm, setConfirm] = useState(false);
  const [date, setDate] = useState({ month: '', year: '' });
  const monthOptions = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' },
  ];
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 25 }, (_, i) => {
    const year = currentYear - i;
    return { value: year, label: year.toString() };
  });

  useEffect(() => {
    handleDate();
  }, []);

  const handleDate = () => {
    const now = new Date();
    const defaultMonthIndex = now.getMonth() === 0 ? 12 : now.getMonth();
    const defaultMonth = defaultMonthIndex;
    const defaultYear = now.getFullYear();
    setDate({ month: defaultMonth, year: defaultYear });
  };

  const [transactionData, setTransactionData] = useState({});
  const [loadingTransactionData, setLoadingTransactionData] = useState(false);

  //   const InvoiceTable = (data, loading) => {
  //     const { Text } = Typography;

  //     const columns = [
  //       ATable.EXPAND_COLUMN,
  //       {
  //         title: 'Invoice ID',
  //         dataIndex: 'invoiceId',
  //         key: 'invoice_id',
  //         render: (value, row) => {
  //           const { isLocked, striked } = row;
  //           return (
  //             <Tooltip
  //               title={
  //                 <>
  //                   {value} {isLocked && <LockOutlined />}
  //                 </>
  //               }
  //             >
  //               <Typography.Text
  //                 delete={striked}
  //                 style={{
  //                   display: 'block',
  //                   overflow: 'hidden',
  //                   whiteSpace: 'nowrap',
  //                   textOverflow: 'ellipsis',
  //                   color: striked ? colors.colorTextTertiary : colors.colorText,
  //                 }}
  //               >
  //                 {value}
  //                 {!isLocked && <LockOutlined style={{ marginLeft: 8 }} />}
  //               </Typography.Text>
  //             </Tooltip>
  //           );
  //         },
  //       },
  //       {
  //         title: 'Contributor',
  //         dataIndex: 'contributorEmail',
  //         key: 'contributor',
  //         render: (text, record) => {
  //           return (
  //             <span style={{ display: 'flex', alignItems: 'center' }}>
  //               <Tooltip title={`(${record.country || ' - '}) ${text}`}>
  //                 <Typography.Text
  //                   delete={record.striked}
  //                   style={{
  //                     width: 300,
  //                     display: 'block',
  //                     overflow: 'hidden',
  //                     whiteSpace: 'nowrap',
  //                     textOverflow: 'ellipsis',
  //                     color: record.striked
  //                       ? colors.colorTextTertiary
  //                       : colors.colorText,
  //                   }}
  //                 >
  //                   {text}
  //                 </Typography.Text>
  //               </Tooltip>
  //             </span>
  //           );
  //         },
  //       },
  //       {
  //         title: 'Invoice Status',
  //         dataIndex: 'invoiceStatus',
  //         key: 'invoice_status',
  //         width: 240,
  //         render: (value, record) => {
  //           return (
  //             <Tooltip title={value}>
  //               <Typography.Text
  //                 style={{
  //                   width: 220,
  //                   display: 'block',
  //                   overflow: 'hidden',
  //                   whiteSpace: 'nowrap',
  //                   textOverflow: 'ellipsis',
  //                 }}
  //               >
  //                 <Tag color={record.invoiceStatusType}>{value}</Tag>
  //               </Typography.Text>
  //             </Tooltip>
  //           );
  //         },
  //       },
  //       {
  //         title: 'Total (in USD)',
  //         dataIndex: 'invoiceGrandTotal',
  //         key: 'total_in_usd',
  //         width: 145,
  //         render: (value) => <>{value}</>,
  //         align: 'right',
  //       },
  //       {
  //         title: 'Created Date',
  //         dataIndex: 'createdAt',
  //         key: 'created_date',
  //         width: 140,
  //         render: (value) => <>{value}</>,
  //       },
  //       {
  //         title: 'Last Modified',
  //         dataIndex: 'updatedAt',
  //         key: 'last_modified',
  //         width: 150,
  //         render: (value) => <>{value}</>,
  //       },
  //     ];

  //     const transaction_columns = [
  //       {
  //         title: 'Transaction ID',
  //         dataIndex: 'transactionId',
  //         key: 'transaction_Id',
  //         width: 220,
  //         render: (value) => {
  //           return (
  //             <Tooltip
  //               title={
  //                 <>
  //                   {value} {<LockOutlined />}
  //                 </>
  //               }
  //             >
  //               <Typography.Text
  //                 style={{
  //                   display: 'block',
  //                   overflow: 'hidden',
  //                   whiteSpace: 'nowrap',
  //                   textOverflow: 'ellipsis',
  //                 }}
  //               >
  //                 {value}
  //                 <LockOutlined
  //                   style={{
  //                     marginLeft: 8,
  //                     width: '16.5px',
  //                     height: '18.75px',
  //                     color: colors.colorIcon,
  //                   }}
  //                 />
  //               </Typography.Text>
  //             </Tooltip>
  //           );
  //         },
  //       },
  //       {
  //         title: 'Type',
  //         dataIndex: 'transactionType',
  //         key: 'transaction_Type',
  //         width: 220,
  //         render: (value) => <>{value}</>,
  //       },
  //       {
  //         title: 'Amount(in USD)',
  //         dataIndex: 'transactionAmount',
  //         key: 'transaction_Amount',
  //         width: 240,
  //         render: (value) => <>{value}</>,
  //         align: 'right',
  //       },
  //       {
  //         title: 'Status',
  //         dataIndex: 'transactionStatus',
  //         key: 'transaction_Status',
  //         width: 220,
  //         render: (value, row) => {
  //           return <Tag color={row.statusVarient}>{value}</Tag>;
  //         },
  //       },
  //       {
  //         title: 'Date',
  //         dataIndex: 'transactionDate',
  //         key: 'transaction_Date',
  //         width: 220,
  //         render: (value) => <>{value}</>,
  //       },
  //     ];
  //     const getStatusType = (status) => {
  //       return (
  //         {
  //           'Contributor Approved': 'default',
  //           'Pending PM Approval': 'default',
  //           'Under Further Review': 'default',
  //           Voided: 'default',

  //           'Ready for Finance Review': 'cyan',
  //           'Ready for Invoice': 'cyan',
  //           'Added to Invoice': 'cyan',
  //           'Added to Payout': 'cyan',

  //           'Payout Pending': 'warning',

  //           'Payout Failure': 'error',

  //           'Payout Completed': 'success',
  //         }[status] || 'default'
  //       );
  //     };
  //     return (
  //       <div style={{ margin: '24px 0' }}>
  //         <ATable
  //           loading={loading}
  //           style={{ height: '100%' }}
  //           columns={columns}
  //           dataSource={data}
  //           pagination={false}
  //           expandable={{
  //             expandRowByClick: true,
  //             showExpandColumn: false,
  //             expandedRowRender: (record) => {
  //               return (
  //                 <div
  //                   style={{
  //                     margin: '0px',
  //                     padding: '4px 48px',
  //                     background: '#0000000A',
  //                   }}
  //                 >
  //                   <Text>
  //                     <Text
  //                       style={{
  //                         size: '18px',
  //                         fontWeight: 600,
  //                         lineHeight: '39px',
  //                       }}
  //                     >
  //                       Associated Transactions
  //                     </Text>
  //                   </Text>
  //                   <ATable
  //                     bordered={true}
  //                     pagination={false}
  //                     style={{ marginBottom: 0 }}
  //                     loading={loadingTransactionData}
  //                     columns={transaction_columns}
  //                     dataSource={transactionData[record.invoiceId]}
  //                     scroll={{
  //                       x: '100%',
  //                       y: 200,
  //                     }}
  //                     size="middle"
  //                   />
  //                 </div>
  //               );
  //             },
  //             onExpand: async (expanded, record) => {
  //               if (expanded) {
  //                 if (!transactionData[`${record.invoiceId}`]) {
  //                   setLoadingTransactionData(true);
  //                   getTransactionByInvoiceId(record.invoiceId)
  //                     .then((res) => {
  //                       let map = res.map((item) => {
  //                         return {
  //                           ...item,
  //                           key: item.transactionId,
  //                           transactionDate: item.transactionDate
  //                             ? moment(item.transactionDate).format('YYYY-MM-DD')
  //                             : 'N/A',
  //                           statusVarient: getStatusType(item.transactionStatus),
  //                         };
  //                       });
  //                       setTransactionData({
  //                         ...transactionData,
  //                         [`${record.invoiceId}`]: map,
  //                       });
  //                     })
  //                     .catch(() => {
  //                       message.error('Failed to fetch invoice data');
  //                     })
  //                     .finally(() => {
  //                       setLoadingTransactionData(false);
  //                     });
  //                 }
  //               }
  //             },
  //           }}
  //           bordered
  //           scroll={{
  //             y: 'calc(100vh - 250px)',
  //           }}
  //         />
  //         <Pagination
  //           style={{
  //             padding: '16px 0',
  //             display: 'flex',
  //             justifyContent: 'end',
  //           }}
  //           pageSize={10}
  //           current={1}
  //           total={30}
  //           //   onChange={handlePageChange}
  //         />
  //       </div>
  //     );
  //   };

  return (
    <>
      <Modal
        title="Create Payouts"
        open={open}
        onCancel={() => setOpen(false)}
        onClose={() => setOpen(false)}
        footer={[
          <Button key="back" onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              setOpen(false);
              handleCreatePayout();
              //   setConfirm(true);
            }}
            disabled={disabled}
          >
            Create Payouts
          </Button>,
        ]}
        centered
      >
        {/* <div style={{ margin: '4px 140px 16px 0px' }}>
          <Text>Set Payout Period</Text>
          <Flex gap={8}>
            <Select
              placeholder="Month"
              style={{ flex: 1 }}
              defaultValue={date?.month}
              options={monthOptions}
              onChange={(v) => setDate({ ...date, month: v })}
            />
            <Select
              placeholder="Year"
              style={{ flex: 1 }}
              defaultValue={date?.year}
              options={yearOptions}
              onChange={(v) => setDate({ ...date, year: v })}
            />
          </Flex>
        </div> */}
        <div>
          <Text>Choose how you would like to compile your payouts:</Text>
          <br />
          <Radio.Group
            defaultValue={createPayoutType}
            onChange={(v) => setCreatePayoutType(v.target.value)}
            options={[
              //   {
              //     value: 'selected',
              //     label: (
              //       <div style={{ margin: '10px 0' }}>
              //         <Text>
              //           Selected invoices only -{' '}
              //           <Text strong>{n || 0} transactions selected</Text>
              //         </Text>
              //         <br />
              //         <Text italic>
              //           Includes only eligible invoices marked as Ready for Payout
              //           or Ready for Finance Review
              //         </Text>
              //       </div>
              //     ),
              //   },
              {
                value: 'all',
                label: (
                  <div style={{ margin: '10px 0' }}>
                    <Text>All invoices</Text>
                  </div>
                ),
              },
            ]}
          />
          {/* {createPayoutType === 'all' && (
            <Radio.Group
              style={{ marginLeft: '20px' }}
              defaultValue={createPayoutSubType}
              onChange={(v) => setCreatePayoutSubType(v.target.value)}
              options={[
                {
                  value: 'payout',
                  label: (
                    <div style={{ margin: '10px 0' }}>
                      <Text>
                        Ready for Payout ONLY -{' '}
                        <Text strong>{n || 0} invoice</Text>
                      </Text>
                    </div>
                  ),
                },
                {
                  value: 'payoutAndReview',
                  label: (
                    <div style={{ margin: '10px 0' }}>
                      <Text>
                        Ready for Payout AND Ready for Finance Review -{' '}
                        <Text strong>{n || 0} invoices</Text>
                      </Text>
                    </div>
                  ),
                },
              ]}
            />
          )} */}
        </div>
      </Modal>
      <Modal
        title="Confirm Payout"
        open={confirm}
        width={'80%'}
        onCancel={() => setConfirm(false)}
        onClose={() => setConfirm(false)}
        footer={[
          <Button key="back" onClick={() => setConfirm(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              setConfirm(false);
            }}
          >
            Confirm
          </Button>,
        ]}
        centered
      >
        <div>
          <Text>
            {`You're about to create a payout for the following`}{' '}
            <Text strong>{n || 0} selected invoices:</Text>
          </Text>
          {/* {InvoiceTable(selectedRecords)} */}
          <Text>Do you want to proceed?</Text>
        </div>
      </Modal>
    </>
  );
}
